import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 0,
    lastPage: 0,
    from: 0,
    to: 0
  },
  usageLogData: null,
  loading: false,
  data: [],
  total: null
}
// FETCH_COMPANY_OPTION

const fetchUsageLogStart = (state, action) => {
  return {
    ...state,
    loading: true
  }
}

const fetchUsageLogSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true,
    usageLogData: action.records,
    pagination: action.pagination
  }
}

const fetchUsageLogFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

// REDUCER
const reducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH_COMPANY_OPTIONS
    case actionTypes.FETCH_USAGE_LOG_SUCCESS:
      return fetchUsageLogSuccess(state, action)
    case actionTypes.FETCH_USAGE_LOG_START:
      return fetchUsageLogStart(state, action)
    case actionTypes.FETCH_USAGE_LOG_FAILED:
      return fetchUsageLogFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    // DEFAULT
    default:
      return state
  }
}

export default reducer
